/* Package JSON Import will be here */
import {
    takeLatest
} from 'redux-saga/effects';
/* Package JSON Import will be here */

/* Project Import will be here */
import {
    REQUEST_APPLICATION_CONFIGURATION
} from '../../actions/applicationConfiguration.Action';
/* Project Import will be here */

function* getAppConfig(action) {
}

function* mySaga() {
    yield takeLatest(REQUEST_APPLICATION_CONFIGURATION, getAppConfig);
}

export default mySaga;